import Vue from 'vue'
import { Loading } from 'element-ui';

// const loading = this.$loading({
//   lock: true,
//   text: '拼命加载中',
//   spinner: 'el-icon-loading',
//   background: 'rgba(0, 0, 0, 0.5)'
// });

var a = {}
let load = {}

load.show = () => {
  a = Loading.service({
    lock: true,
    text: '拼命加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.5)'
  })
}

load.close = () => {
  a.close()
}

Vue.prototype.$load = load
export default load
